import { ProductType } from "../../types/product";

export default function ProductTypeBadge({ productType }: { productType: ProductType }) {
  switch (productType) {
    case "simple":
      return <SquareBadge color="bg-green-400">S</SquareBadge>;
    case "variationParent":
      return <SquareBadge color="bg-purple-400">P</SquareBadge>;
    case "variationChild":
      return <SquareBadge color="bg-indigo-400">C</SquareBadge>;
    case "custom":
      return <SquareBadge color="bg-orange-400">U</SquareBadge>;
    case "recycle":
      return <SquareBadge color="bg-red-400">R</SquareBadge>;
    case "bundle":
      return <SquareBadge color="bg-yellow-400">B</SquareBadge>;
    case "giftCard":
      return <SquareBadge color="bg-blue-400">G</SquareBadge>;
    default:
      return <div></div>;
  }
}

function SquareBadge({ color, children }: { color: string; children: React.ReactNode }) {
  return <div className={`${color} w-[20px] h-[20px] flex justify-center item-center text-white`}>{children}</div>;
}
